import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';

const DoctorContainer = dynamic(
  () => import('@containers/doctor/profile/[id]/_components/container'),
);

const DoctorProfilePage = () => {
  const { query } = useRouter();

  const doctorId = Number(query?.id);

  return <DoctorContainer doctorId={doctorId} />;
};

export default DoctorProfilePage;
